import { env } from "@anima/env/server";
import { drizzle } from "drizzle-orm/d1";

import * as schema from "./schema";

export type Db = ReturnType<typeof drizzle<typeof schema>>;

/** Pure factory — pass a D1Database binding. */
export function createDb(db: D1Database) {
  return drizzle(db, { schema });
}

/** Convenience — resolves D1 from Cloudflare context via @anima/env. */
export function getDb() {
  return createDb(env.DB);
}

export async function getDbAsync() {
  return createDb(env.DB);
}

export const getDbAsyncUncached = getDbAsync;
